module.exports = __webpack_public_path__ + "static/footer-image-d980102fc0c0beb4fab727c98a4abb71.png";